import {NumberInputProps} from 'common/types';
import {FC} from 'react';
import {FiMinus, FiPlus} from 'react-icons/fi';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Label = styled.label`
  width: 100%;
  font-family: ${({theme}) => theme.fonts.teko};
`;

const Error = styled.span`
  width: 100%;
  color: ${({theme}) => theme.colors.red};
  font-size: ${({theme}) => theme.fontSize(0.65)}px;
  line-height: ${({theme}) => theme.fontSize(0.65)}px;
  margin-top: ${({theme}) => theme.spacing(0.25)}px;
`;

const InputWrapper = styled.div<{hasError?: boolean}>`
  width: 100%;
  border: 1px solid ${({theme, hasError}) => (hasError ? theme.colors.red : theme.colors.blue)};
  border-radius: 5px;
  transition: border 250ms ease-in-out;
  display: flex;
  flex-direction: row;
  overflow: hidden;
`;

const InputValue = styled.div`
  flex: 1;
  padding: ${({theme}) => theme.spacing(0.75)}px ${({theme}) => theme.spacing(0.75)}px;
  color: ${({theme}) => theme.colors.black};
  font-size: ${({theme}) => theme.fontSize(0.75)}px;
  line-height: ${({theme}) => theme.fontSize(0.75)}px;
  font-weight: 500;
  text-align: center;
  background: ${({theme}) => theme.colors.white};
`;

const InputButton = styled.button<{disabled: boolean}>`
  width: 45px;
  height: 45px;
  border: none;
  border-radius: 0;
  background-color: #4c7e8d;
  color: white;
  font-size: 1.5em;
  line-height: 1.15em;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease-in-out;
  &:hover {
    opacity: 0.8;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
  &:focus {
    box-shadow: none;
  }
`;

const NumberInput: FC<NumberInputProps> = ({label, hasError, error, min, max, value, onChange}) => {
  const decrease = () => {
    if (value === min) return;
    onChange(value - 1);
  };
  const increase = () => {
    if (value === max) return;
    onChange(value + 1);
  };
  return (
    <Container>
      {label && <Label>{label}</Label>}
      <InputWrapper hasError={hasError}>
        <InputButton disabled={value === min} onClick={decrease} type='button'>
          <FiMinus size={24} />
        </InputButton>
        <InputValue>{value}</InputValue>
        <InputButton disabled={value === max} onClick={increase} type='button'>
          <FiPlus size={24} />
        </InputButton>
      </InputWrapper>
      {hasError && <Error>{error}</Error>}
    </Container>
  );
};

export default NumberInput;
